module.exports = __webpack_public_path__ + "img/thumbnail_CommonOstrich_f_normal.c9af25fe.png";